/**
 * Policy — the system-of-record document a portal publishes for acceptance.
 * Derived from coreBOS `evPolicies` (policies.evolutivo.ai), GDPR threat-management dropped.
 */
export const policiesDescriptor = {
    slug: 'policy',
    kind: 'document',
    label: { singular: 'Policy', plural: 'Policy' },
    table: 'ai_portal_policy',
    idStrategy: 'sha256',
    fields: [
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'policystatus', type: 'text', label: 'Stato' },
        { name: 'policy_type', type: 'text', label: 'Tipo Policy' },
        { name: 'policyisactive', type: 'boolean', label: 'Attiva' },
        { name: 'policyversion', type: 'text', label: 'Versione' },
        { name: 'effectivsince', type: 'date', label: 'In vigore da' },
        { name: 'policyreviewdate', type: 'date', label: 'Data revisione' },
        { name: 'allow_upload', type: 'boolean', label: 'Consenti upload' },
        { name: 'model', type: 'text', label: 'Modello' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [
        { name: 'policytoaccount', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
        { name: 'documents', kind: 'hasMany', target: 'document' },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        documents: true,
        softDelete: true,
        tenantScoped: true,
    },
    emits: ['policy.created', 'policy.updated', 'policy.published'],
    ui: { mode: 'generated', icon: 'FileProtectOutlined', navGroup: 'Policy e contenuti', navOrder: 40 },
};
